import {Component, OnInit} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-crediti-confirmation-dialog-component',
  templateUrl: './delete-crediti-confirmation-dialog-component.component.html',
  styleUrls: ['./delete-crediti-confirmation-dialog-component.component.scss']
})
export class DeleteCreditiConfirmationDialogComponentComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<string>,
  ) {
  }
  onNoClick(): void {
    this.dialogRef.close(null);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
  ngOnInit(): void {
  }

}
